import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from './auth';
import TeacherModule from './teacher';
import EmployeeModule from './employee';
import CourseModule from './course';
import StudentModule from './student';
import ClaimModule from './claim';
import SchoolModule from './school';
import {routeDefs} from '../routes';

Vue.use(Vuex);


export async function bindLoading(commit, action, ns = '', options = {delay: 200, ignoreGlobal: false}) {
    commit({
        type: 'saveLoading',
        loading: true,
        ns,
        ignoreGlobal: options.ignoreGlobal
    }, {root: true});

    await new Promise(resolve => {
        setTimeout(() => resolve(true), options.delay)
    });

    const result = await action();

    commit({
        type: 'saveLoading',
        loading: false,
        root: true,
        ns
    }, {root: true});
    return result;
}

export default new Vuex.Store({
    modules: {
        auth: AuthModule,
        teacher: TeacherModule,
        course: CourseModule,
        claim: ClaimModule,
        employee: EmployeeModule,
        student: StudentModule,
        school: SchoolModule,
    },
    state: {
        loading: {
            global: false,
            actions: {}
        },
    },
    getters: {
        menuDefs(state) {
            const filterFunc = r => r.show &&
                (r.claims.length <= 0 ||
                    r.claims.some(c => state.auth.claims.some(cc => cc === c))
                );
            const subMenusGrp = routeDefs
                .filter(r => r.parent)
                .filter(filterFunc)
                .reduce((grp, {title, path, exact, name, parent}) => {
                    (grp[parent]
                        = (grp[parent] || []))
                        .push({title, path, exact, name});
                    return grp;
                }, {});
            const topMenus = routeDefs
                .filter(r => !r.parent)
                .filter(filterFunc)
                .map(t => ({
                    ...t,
                    children: subMenusGrp.hasOwnProperty(t.name) ? subMenusGrp[t.name] : []
                }));
            return topMenus
                .map(({title, path, exact, name, children}) => ({title, path, exact, name, children}));
        }
    },
    mutations: {
        saveLoading(current, {loading, ns = '', ignoreGlobal = false}) {
            current.loading.global = ignoreGlobal ? false : loading;

            if (ns) {
                if (current.loading.actions.hasOwnProperty(ns)) {
                    current.loading.actions[ns] = loading;
                } else {
                    Vue.set(current.loading.actions, ns, loading);
                }
            }
        },
        resetLoading(current) {
            current.loading.global = false;
            Vue.set(current.loading, 'actions', {});
        }
    },
    actions: {

    }
});